import { render, staticRenderFns } from "./inDetailList.vue?vue&type=template&id=b6a7fe58&"
import script from "./inDetailList.vue?vue&type=script&lang=js&"
export * from "./inDetailList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports